import React from 'react';
import classNames from 'classnames';
import { find, includes, map, propEq, propOr } from 'ramda';
import { isNilOrEmpty, isNotNil, mapIndexed } from '../../../../server/helpers/index.mjs';

// Bloc « Options » : une ligne par option, une carte cliquable dans chaque colonne où l'option existe.
// Sans tarif (hors ticket), la carte affiche « Sélectionner » / « Sélectionnée ».
const Options = ({
  getMiddleText,
  displayedPricings,
  options,
  isSelected,
  selectedOptions,
  toggleOption
}) => (
  <div
    className={'grid border rounded-xl shadow-lg w-full'}
    style={{
      gridTemplateColumns: `300px repeat(${displayedPricings.length}, minmax(150px, 1fr))`
    }}
  >
    <div className={'col-span-full flex font-bold p-4 sticky top-0 z-20 bg-white'}>
      <span className={'sticky left-0'}>{getMiddleText('NIVEAUXGARANTIESETTARIFS_OPTIONS_LABEL')}</span>
    </div>

    {isNilOrEmpty(options) && (
      <div className="col-span-full p-8 text-center text-gray-500">
        Aucune option disponible pour les formules affichées
      </div>
    )}

    {map(
      (option) => (
        <div key={option.value} className={'contents'}>
          <div className={'ml-4 p-4 font-bold sticky left-0 z-10 bg-white'}>
            <div className={'p-2'}>{option.label}</div>
          </div>
          {mapIndexed(({ pricingLabel, options: pricingOptions, optionsSelectionMode }, index) => {
            const isLast = index === displayedPricings.length - 1;
            const pricingSelected = isSelected(pricingLabel);
            const isOptionSelected = includes(option.value, propOr([], pricingLabel, selectedOptions));
            const hasOption = isNotNil(find(propEq('optionCode', option.value), pricingOptions));

            return (
              <div
                key={pricingLabel + option.value}
                className={classNames('flex flex-col items-center justify-start mx-1', {
                  'border-r border-l': !isLast,
                  'border-l': isLast,
                  'cursor-not-allowed': hasOption && !pricingSelected,
                  'cursor-pointer': hasOption && pricingSelected
                })}
                onClick={() => {
                  if (hasOption && pricingSelected) {
                    toggleOption(pricingLabel, option.value, optionsSelectionMode);
                  }
                }}
                data-testid={`${pricingLabel}-${option.value}`}
              >
                {hasOption && (
                  <div className="relative flex flex-col items-center w-4/5 my-4">
                    <div
                      className={classNames(
                        'border rounded-lg w-full p-2 text-center border-primary-300',
                        {
                          'bg-white text-primary': !isOptionSelected || !pricingSelected,
                          'bg-primary-300 text-white': pricingSelected && isOptionSelected
                        }
                      )}
                    >
                      {pricingSelected && isOptionSelected ? 'Sélectionnée' : 'Sélectionner'}
                    </div>
                  </div>
                )}
              </div>
            );
          }, displayedPricings)}
        </div>
      ),
      options
    )}
  </div>
);

export default Options;
